import { create } from 'zustand';

interface BannerCollapseState {
  isCollapsed: boolean;
  setCollapsed: (isCollapsed: boolean) => void;
}

const useBannerCollapseStore = create<BannerCollapseState>(set => ({
  isCollapsed: false,
  setCollapsed: (isCollapsed: boolean) => set({ isCollapsed }),
}));

export default useBannerCollapseStore;
